<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-modal id="order-template-modal" @ok="pdfData" header-class="p-0"
        footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
        <template #modal-title>
            <div class="title-block text-center p-2">{{ $translate('export_statement') }}</div>
            <div class="close-btn" @click="cancel()">x</div>
        </template>
        <form class="my-3 py-3" @submit.stop.prevent="pdfData">
    
          <b-row>
              <b-col cols="12" class="mb-3">
                  <label><strong>{{ $translate('select_option') }}</strong></label>
              </b-col>
              <b-col cols="auto" class="mb-3">
                  <b-form-radio
                      v-model="export_option"
                      name="export_option"
                      value="pdf"
                      class="mx-1"
                  >&nbsp;{{$translate('PDF')}}</b-form-radio>
              </b-col>
              <b-col cols="auto" class="mb-3">
                  <b-form-radio
                      v-model="export_option"
                      name="export_option"
                      value="word"
                      class="mr-2"
                  >&nbsp;{{$translate('Word')}}</b-form-radio>
              </b-col>
          </b-row>
      
      </form>
      
        <template #modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="info" @click="ok()">{{ $translate('export') }}</b-button>
            <b-button size="sm" variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>
    
        </template>
    </b-modal>
        <b-card class="p-3">
            
            <b-col class="page-block">
                <strong>
                    {{ $translate("page") }}: {{ pagination.page }}
                    {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                    {{ pagination.total }}
                </strong>
            </b-col>
            <b-card-header class="assets-filter">
                <b-row class="mt-3">
                    <b-col cols="12" md="12">
                        <div class="d-flex">
                            <b-button variant="blue-button"  class="me-2"
                                @click="toggle_filters = !toggle_filters">
                                {{ $translate('filters') }}
                                <b-icon class="ms-1" :icon="'chevron-' +
                                    (toggle_filters ? 'up' : 'down')
                                    " variant="dark"></b-icon>
                            </b-button>
                            <b-button variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                                :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </b-button>
                            <b-button variant="blue-button" @click="exportData" v-b-tooltip.hover
                            :title="$translate('export_data')" class="mx-2 float-right">
                            Excel
                        </b-button>
                        <b-button variant="blue-button" @click="openModal" v-b-tooltip.hover
                        :title="$translate('pdf_data')" class="float-right">
                        <b-icon icon="printer-fill"  variant="dark"></b-icon>


                    </b-button>
                        </div>
                    </b-col>
                    <!-- <b-col cols="12" md="6" class="p-0 pe-md-3 d-flex text-right align-items-center">
                        <slot></slot>
                    </b-col> -->
                </b-row>
                <RentalFilters v-show="toggle_filters" v-model="filters" />
            </b-card-header>
            <b-card-body>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage"
                        :current-page="currentPage" :filter="filters" show-empty>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="{ item }">
                            <!-- <b-button v-if="hasPermissionView" @click="$emit('show-item', item.id)" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button> -->
                            <b-button  @click="$emit('show-item', item.id)" v-if="allowToUpdatePayment" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                        <template #cell(activity)="{ item }">
                          
                          
                                
                                <b-link :to="`/ams/activities/${item.activity.id}`">
                                    {{ item.activity.reference_no }}</b-link>
                              
                               
                             
                        </template>
                        <template #cell(current_address)="{ item }">
                           <div v-html="getFormattedAddress(item)"></div>     
                        </template>
                        <template #empty>
                            <div class="text-center">No Data Available</div>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination
                            class="justify-content-center mt-4"
                            v-model="pagination.page"
                            :total-rows="pagination.total"
                            :per-page="pagination.pageSize"
                            aria-controls="customerTable"
                            :prev-text="$translate('previous')"
                            :next-text="$translate('next')"
                            pills
                            align="center"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import addActivityTypeIcon from '@/assets/images/icon/blue-add.svg'
import permissionsMixins from '@/mixins/permissionsMixins'
import RentalFilters from './RentalFilters.vue'

const defaultModel = Object.freeze({
    created_start: moment().subtract(30, 'days').format('YYYY-MM-DD'),

    created_end: moment().format('YYYY-MM-DD'),
})

export default {
    name: 'Rentals-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'title'],
    components: { RentalFilters },

    data() {
        return {
            query: "",
            toggle_filters: false,
            filters: {
                order_search: "",
                transactionFromDate: defaultModel.created_start,
                transactionToDate: defaultModel.created_end,
                payment_transaction_status: null,
                payment_transaction_type: null,
                customer_id :null,
                total_amount: null,
                quantityType: 3,
            },
            icon: addActivityTypeIcon,
            itemsPerPage: 15,
            currentPage: 1,
            tableLoading: false,
            export_option : "",
          
        }
    },
    mounted() {
        const { query } = this.$route;
        if (query.query) this.query = query.query;

        if (query.order_search)
            this.$set(this.filters, "order_search", query.order_search);

        this.doSearch(true)
    },
    filters: {
        filterStatusVariant(item) {
            let badgeClass = '';
            switch (item.payment_transaction_status) {
                case 'pending':
                    badgeClass = 'primary';
                    break;
                case 'processed':
                    badgeClass = 'success';
                    break;
                case 'cancelled':
                    badgeClass = 'danger';
                    break;
            
                default:
                    badgeClass = 'primary';
                    break;
            }
            return badgeClass;
        },
    },
    watch: {
        items: {
            handler: function () {
                // this.tableLoading = false
            },
            deep: true,
        },

        filters: {
            handler: function () {
                console.log('customer is changes!');
                this.doSearch(true)
            },
            deep: true,
        },

        "pagination.page": function () {
            this.doSearch();
        },
    },

    computed: {
        fields() {
            return [
                // { key: 'id', label: this.$translate('actions') },
                {
                    key: 'activity',
                    label: this.$translate('activity_no'),
                    formatter: (value) =>value && (value.reference_no),
                },
                {
                    key: 'customer_code',
                    label: this.$translate('customer_code'),
                    formatter: (value, key, item) => item.activity?.customer?.code 
                },
                {
                    key: 'customer',
                    label: this.$translate('customer_name'),
                    formatter: (value, key, item) => item.activity?.customer?.name 
                },
                {
                    key: 'item_type',
                    label: this.$translate('item_type'),
                    formatter: (value, key, item) => item.asset?.master_item?.type?.name 
                },
                {
                    key: 'master_item',
                    label: this.$translate('master_item'),
                    formatter: (value, key, item) => item.asset?.master_item?.name 
                },
                {
                    key: 'asset_name',
                    label: this.$translate('asset_name'),
                    formatter: (value, key, item) => item.asset?.name 
                },
                {
                    key: 'asset_serial_no',
                    label: this.$translate('asset_serial_no'),
                    formatter: (value, key, item) => item.asset?.serial_no 
                },
                {
                    key: 'asset_modal_no',
                    label: this.$translate('asset_modal_no'),
                    formatter: (value, key, item) => item.asset?.model_no 
                },
                { key: 'start_rental_at', label: this.$translate('start_rental_at') },
                { key: 'estimated_rental_days', label: this.$translate('estimated_rental_days') },
                { key: 'estimated_rental_rate', label: this.$translate('estimated_rental_rate') },
                {
                    key: 'estimated_total_rental_amount',
                    label: this.$translate('estimated_total_rental_amount'),
                    formatter: (value, key, item) => {
                            const estimatedRentalAmount = parseFloat(item.estimated_rental_days) * parseFloat(item.estimated_rental_rate);
                            return estimatedRentalAmount.toFixed(2); // Format the value to 2 decimal places
                        }
 
                },
                { key: 'actual_rental_rate', label: this.$translate('actual_rental_rate') },
                { key: 'actual_returned_at', label: this.$translate('actual_returned_at') },
                {
                    key: 'asset_returned_by',
                    label: this.$translate('asset_returned_by'),
                    formatter: (value, key, item) => {
                     
                        if (item.returned_by_user) {
                        
                        return item.returned_by_user.first_name + ' ' + item.returned_by_user.last_name;
                        } else {
                     
                        return '';
                        }
                    }
                    },
               
                { key: 'actual_total_rental_amount', label: this.$translate('actual_total_rental_amount') },
                { key: 'current_address',label : this.$translate('current_address')}
                
            ]
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        },
        
        item() {
            // console.log('this is getting computed-', this.$store.state.asset_rental.items)
            const item= this.$store.state.asset_rental.item
           
            return item
        },
        items() {
            // console.log('this is getting computed-', this.$store.state.asset_rental.items)
            const items = this.$store.state.asset_rental.items
            console.log('items', items)
            return items
        },
        attachments() {
            console.log('This is attachments-----', this.$store.state.paymentAttachmentsStore.attachments)
            return this.$store.state.paymentAttachmentsStore.attachments
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.asset_rental.pagination || { page: 1 };
        },
        allowToUpdatePayment() {
            return !!this.user_permissions.includes(
              "update.payments"
             );
        },
    },

    methods: {
        resetFilters() {
            this.filters = {
                order_search: "",
                transactionFromDate: defaultModel.created_start,
                transactionToDate: defaultModel.created_end,
                payment_transaction_status: null,
                payment_transaction_type: null,
            }
            this.doSearch()
        },
        async doSearch(isforcedReload = false) {

            let {
                query,
                pagination: { page },
                filters
            } = this
            
            if(filters.order_search !="" && filters.order_search.length < 3) return;
            
            page = parseInt(page) || 1;
            
            this.tableLoading = true
            try{
                await this.$store.dispatch('asset_rental/fetchAll', {
                    query,
                    filters,
                    page,
                    isforcedReload
                })
            } catch(err) {
                console.log('Payment fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
            }
        },
        async exportData() {
       
         
            let {
                query,
                filters
            } = this
            
            if(filters.order_search !="" && filters.order_search.length < 3) return;
            
            this.tableLoading = true
            await  this.$store.dispatch('asset_rental/exportExcel', {
                query,
                filters,
            })
            this.tableLoading = false
        },
        async openModal(){
         this.$bvModal.show('order-template-modal')
       },
        async pdfData() {
       
                
            let {
                query,
                filters,
                export_option
            } = this
            
            if(filters.order_search !="" && filters.order_search.length < 3) return;
            
            this.tableLoading = true
            await  this.$store.dispatch('asset_rental/exportPDF', {
                query,
                filters,
                export_option
            })
            this.tableLoading = false
       },
        getFormattedAddress(item) {
            const location = item.asset?.location_section?.location;
            if (!location) {
            return ''; // Return an empty string if location is not available
            }
            
            const name = location.name || '';
            const address1 = location.address1 || '';
            const address2 = location.address2 || '';
            const city = location.city || '';
            const postal_code = location.postal_code || '';
            // Initialize an array to hold non-empty address parts
            const addressParts = [];

            // Add non-empty parts to the array
            if (name) addressParts.push(name);
            if (address1) addressParts.push(address1);
            if (address2) addressParts.push(address2);
            if (city) addressParts.push(city);
            if (postal_code) addressParts.push(postal_code);
            
            // Join the parts with '<br>' to create a formatted address
            return addressParts.join('<br>');
        }
    },
}
</script>
<style scoped>
.float-right{
    float:right !important;
}
</style>
